import { apiClient } from './api';
import type {
  Podcast,
  PodcastSearchResponse,
  SearchPodcastPayload,
  SavePodcastPayload,
  ApiResponse,
} from '../types/api.types';

export const podcastsService = {
  // Search for podcasts by name (returns multiple results)
  searchPodcast: async (payload: SearchPodcastPayload): Promise<PodcastSearchResponse> => {
    const { data } = await apiClient.post<PodcastSearchResponse>('/search/podcast', payload);
    return data;
  },

  // Get episodes for a specific podcast
  getPodcastEpisodes: async (payload: SearchPodcastPayload): Promise<Podcast> => {
    const { data } = await apiClient.post<Podcast>('/podcast/episodes', payload);
    return data;
  },

  // Add a podcast episode to a project
  addEpisodeToProject: async (
    projectId: number,
    payload: SavePodcastPayload
  ): Promise<ApiResponse> => {
    const { data } = await apiClient.post<ApiResponse>(
      `/save/podcast/${projectId}`,
      payload
    );
    return data;
  },

  // Get podcasts by project ID
  getPodcastsByProject: async (projectId: number): Promise<Record<string, Podcast>> => {
    const { data } = await apiClient.get<Record<string, Podcast>>(
      `/retrieve/podcasts/${projectId}`
    );
    return data;
  },

  // Delete episode from project
  deleteEpisode: async (projectId: number, episodeId: number): Promise<ApiResponse> => {
    const endpoint = `/delete/episode/${projectId}`;
    const payload = { episodeId };
    console.log('Calling deleteEpisode API:', endpoint, 'with payload:', payload);
    const { data } = await apiClient.post<ApiResponse>(
      endpoint,
      payload
    );
    console.log('deleteEpisode response:', data);
    return data;
  },

  // Update episode last accessed timestamp
  updateEpisodeAccess: async (episodeId: number): Promise<ApiResponse> => {
    const { data } = await apiClient.post<ApiResponse>(
      `/episode/access/${episodeId}`
    );
    return data;
  },

  // Upload a local audio file directly as a new episode for a project.
  // apiClient defaults Content-Type to application/json on every request;
  // that overrides axios's automatic multipart boundary detection for
  // FormData bodies, so it must be explicitly cleared here (undefined lets
  // axios set its own Content-Type, including the boundary parameter the
  // server needs to parse a multipart body at all).
  uploadAudioFile: async (
    projectId: number,
    formData: FormData
  ): Promise<{ status: string; message: string; podcastId?: number }> => {
    const { data } = await apiClient.post<{ status: string; message: string; podcastId?: number }>(
      `/podcasts/upload-audio/${projectId}`,
      formData,
      { headers: { 'Content-Type': undefined } }
    );
    return data;
  },
};
